import { BrandInfo } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/BrandInfo";
import { DebugInfoSection } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/DebugInfoSection/DebugInfoSection";
import { SearchProductImageClient } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/search/SearchProductImageClient";
import { PriceWithClientFormatMoney } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/PriceWithClientFormatMoney";
import { UnlockWholesalePriceLink } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/UnlockWholesalePriceLink";
import { ProductName } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProductName";
import { SearchProductLink } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/SearchProductLink";
import { MaybeSearchProductTileClickProvider } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/search/SearchProductTileClickProvider";
import { ProductTileContainer } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileContainer/ProductTileContainer";
import { ProductTileTrackingWrapper } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileTrackingWrapper/ProductTileTrackingWrapper";
import { ProductTileUpperContainer } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileUpperContainer/ProductTileUpperContainer";
import { TopBadges } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TopBadges/TopBadges";
import { ProductTileContextProvider } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileContextProvider";
import { ProductTileSwatches } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileSwatches";
import { DiscoverProductTileProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/DiscoverProductTileProps";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";

export const LoggedOutSearchProductTile = ({
  data,
}: {
  data: DiscoverProductTileProps;
}) => {
  const {
    productTileImageClientProps,
    productTileTrackingWrapperProps,
    productTileDebugInfoProps,
    productTileTopBadgesProps,
    productTileClickProviderProps,
    brand,
    priceTextProps,
    shouldHidePriceProminencePriceTestV3,
    productName,
    productOptionDetails,
    brandInfoData,
  } = data;

  return (
    <ProductTileContextProvider brandToken={brand?.token} brand={brand}>
      <ProductTileTrackingWrapper
        data={productTileTrackingWrapperProps}
        brandToken={brand?.token}
      >
        <MaybeSearchProductTileClickProvider
          data={productTileClickProviderProps}
        >
          <ProductTileContainer>
            <ProductTileUpperContainer>
              <SearchProductLink data={productTileClickProviderProps}>
                <SearchProductImageClient data={productTileImageClientProps} />
              </SearchProductLink>
              <TopBadges data={productTileTopBadgesProps} />
              <DebugInfoSection data={productTileDebugInfoProps} />
            </ProductTileUpperContainer>
            <Spacer size={{ mobileAndAbove: "1x", tabletAndAbove: 12 }} />
            <SearchProductLink data={productTileClickProviderProps}>
              <ProductName productName={productName} />
              <PriceWithClientFormatMoney
                {...priceTextProps}
                shouldHidePriceProminencePriceTestV3={
                  shouldHidePriceProminencePriceTestV3
                }
              />
              <ProductTileSwatches optionDetails={productOptionDetails} />
            </SearchProductLink>
            <BrandInfo data={brandInfoData} />
            {shouldHidePriceProminencePriceTestV3 ? (
              <SearchProductLink data={productTileClickProviderProps}>
                <UnlockWholesalePriceLink />
              </SearchProductLink>
            ) : null}
          </ProductTileContainer>
        </MaybeSearchProductTileClickProvider>
      </ProductTileTrackingWrapper>
    </ProductTileContextProvider>
  );
};
